<object class="document" [data]="url()" [type]="document.mimeType"></object>
